export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_ALL_LOCATIONS = 'SET_ALL_LOCATIONS'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_STORES_LOADED = 'SET_STORES_LOADED'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const SET_STORE_NAME = 'SET_STORE_NAME'
export const SET_STORE_ID = 'SET_STORE_ID'
export const TOGGLE_EDIT_OVERLAY = 'TOGGLE_EDIT_OVERLAY'
export const SET_CURRENT_STORE = 'SET_CURRENT_STORE'
export const SET_CURRENT_STORE_NAME = 'SET_CURRENT_STORE_NAME'
export const SET_CURRENT_STORE_ID = 'SET_CURRENT_STORE_ID'
export const TOGGLE_STATUS = 'TOGGLE_STATUS'
export const TOGGLE_CURRENT_STATUS = 'TOGGLE_CURRENT_STATUS'
export const SET_ITEMS = 'SET_ITEMS'
export const SET_PAGE_OF_ITEMS = 'SET_PAGE_OF_ITEMS'
export const SET_SERACH_VALUE_ON_CLICK = 'SET_SERACH_VALUE_ON_CLICK'